module.exports = "https://static.wshopon.com/static/v1.3.2-rc.1/store/images/no-image.3a38d5.gif";